import { FC } from 'react'

import clsx from 'clsx'

import { DayProps } from '../model'

import s from './styles.module.scss'

export const SelectedDay: FC<DayProps> = ({
  day,
  content,
  isGreen,
  isEnd,
  isStart,
  onClick,
}) => {
  return (
    <div
      className={s.container}
      onClick={() => onClick?.(day)}
    >
      <p className={clsx('bold-14')}>{day}</p>
      <span className={clsx('regular-10', { [s.green]: isGreen })}>
        {content}
      </span>

      {isEnd && <span className={clsx(s.end)} />}
      {isStart && <span className={clsx(s.start)} />}
    </div>
  )
}
